{
  "states": {
    "loading": "লোড হচ্ছে...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "সান ফ্রান্সিসকো"
  },
  "conditions": {
    "Clear": "পরিষ্কার",
    "Clouds": "মেঘলা",
    "Rain": "বৃষ্টি",
    "Drizzle": "গুঁড়ি বৃষ্টি",
    "Thunderstorm": "বজ্রঝড়",
    "Snow": "তুষার",
    "Mist": "কুয়াশা",
    "Smoke": "ধোঁয়া",
    "Haze": "ধোঁয়াশা",
    "Dust": "ধুলো",
    "Fog": "ঘন কুয়াশা",
    "Sand": "বালি",
    "Ash": "ছাই",
    "Squall": "দমকা হাওয়া",
    "Tornado": "টর্নেডো"
  },
  "modal": {
    "defaultTitle": "আবহাওয়া",
    "subtitle": "বর্তমান অবস্থা",
    "showFahrenheit_aria": "ফারেনহাইট দেখান",
    "showCelsius_aria": "সেলসিয়াস দেখান",
    "switchToCelsius_title": "°C-এ পরিবর্তন করুন",
    "switchToFahrenheit_title": "°F-এ পরিবর্তন করুন",
    "feelsLike": "অনুভূত হয় {{temp}}°{{unit}}",
    "humidityWind": "আর্দ্রতা {{humidity}}% · বাতাস {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "এখন",
    "hourlyOffset": "{{hours}}ঘ",
    "hourlyStrip_aria": "ঘণ্টাভিত্তিক তাপমাত্রা",
    "hourlyLocked": "ঘণ্টাভিত্তিক পূর্বাভাস একটি Pro বৈশিষ্ট্য।",
    "statsLocked": "আবহাওয়ার বিবরণ একটি Pro বৈশিষ্ট্য।",
    "stats": {
      "sunrise": "সূর্যোদয়",
      "sunset": "সূর্যাস্ত",
      "feels": "অনুভূত",
      "humidity": "আর্দ্রতা",
      "wind": "বাতাস",
      "rain": "বৃষ্টি"
    },
    "rainInches": "{{value}} ইঞ্চি",
    "forecastTitle": "৫-দিনের পূর্বাভাস",
    "forecastLoading": "পূর্বাভাস লোড হচ্ছে…",
    "forecastUnavailable": "পূর্বাভাস অনুপলব্ধ",
    "forecastLocked": "৫-দিনের পূর্বাভাস একটি Pro বৈশিষ্ট্য।",
    "forecastRow_aria": "পাঁচ দিনের পূর্বাভাস",
    "proHeadline": "সম্পূর্ণ পূর্বাভাস Pro-এর অংশ।",
    "proFeatures": "প্রতি ঘণ্টায় · বিস্তারিত অবস্থা · ৫ দিনের পূর্বাভাস।"
  }
}
